import * as types from "../../constants";

export type SetFacilitiesType = {
  type: typeof types.SET_FACILITIES;
  facilities: string[];
};
export function setFacilities(facilities: string[]): SetFacilitiesType {
  return {
    type: types.SET_FACILITIES,
    facilities: facilities,
  };
}
